import React, { Fragment, useContext } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, Btn, H4, H5 } from "../../../../AbstractElements";
import CheckoutTableData from "./CheckoutTableData";
import ProductPlaceOrder from "./ProductPlaceOrder";
import HeaderCard from "../../../Common/Component/HeaderCard";
import { useNavigate, useLocation } from "react-router-dom";
import CustomizerContext from "../../../../_helper/Customizer";

const CheckOut = () => {
  const { layoutURL } = useContext(CustomizerContext);
  const history = useNavigate();

  const location = useLocation();

  const { rowData, data, permission } = location.state || {};

  const handleView = () => {
    history(`${process.env.PUBLIC_URL}/invoice/${layoutURL}`, {
      state: { data, rowData },
    });
  };
  return (
    <Fragment>
      <Breadcrumbs parent="Ecommerce" title="Checkout" mainTitle="Checkout" />
      <Container fluid={true}>
        <Row>
          <Col>
            <Card className="checkout">
              <div className="d-flex justify-content-between align-items-center">
                {/* <HeaderCard title={"Billing Details"} /> */}
                <CardHeader>
                  <H4> {"Billing Details"} </H4>
                </CardHeader>
                <CardHeader>
                    <Btn attrBtn={{ color: "success", onClick: handleView }}>
                      {"View Invoice"}
                    </Btn>
                  </CardHeader>
              </div>
              <CardBody>
                <Row>
                  <CheckoutTableData rowData={rowData} data={data}  permission= {permission}/>
                  <ProductPlaceOrder rowData={rowData} data={data} />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default CheckOut;
